import { SIGNOUT } from "../definitions";

const initialStates = {
  signOut: null,
  error: "",
};

const signOutReducer = (state = initialStates, action) => {
  switch (action.type) {
    case SIGNOUT.SIGNOUT_START_FETCH: {
      return {
        ...state,
        signOut: null,
      };
    }
    case SIGNOUT.SIGNOUT_FINISH_FETCH: {
      return {
        ...state,
        signOut: action.payload,
        error: "",
      };
    }
    case SIGNOUT.SIGNOUT_FAIL_FETCH: {
      return {
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export { signOutReducer };
